import { Link } from "react-router-dom";
import { ArrowLeft, ArrowRight, ShieldOff } from "lucide-react";

import { Button } from "@/components/ui/button";

/**
 * O ecrã de porta fechada.
 *
 * Sem cartão, sem disco vermelho e sem título a gritar: quem chega aqui já está
 * contrariado, e um aviso enorme só piora. É uma página calma que explica o que
 * se passa e dá dois caminhos de saída. A única cor é o ícone — e mesmo esse
 * discreto, porque não houve avaria nenhuma: o sistema fez o que devia.
 */
export const AccessDeniedPage = () => (
  <div className="flex min-h-[70vh] items-center justify-center px-6 py-16">
    <div className="w-full max-w-md text-center">
      <ShieldOff
        className="mx-auto h-6 w-6 text-muted-foreground/40"
        strokeWidth={1.5}
        aria-hidden
      />

      <p className="mt-6 text-[11px] font-medium uppercase tracking-[0.18em] text-muted-foreground">
        Sem acesso
      </p>

      <h1 className="mt-3 text-3xl font-light tracking-tight text-foreground">
        Esta página não é para ti
      </h1>

      <p className="mt-4 text-sm leading-relaxed text-muted-foreground">
        O teu departamento não tem acesso a esta funcionalidade. Se achas que devia ter, fala
        com o administrador do sistema.
      </p>

      <div className="mt-8 flex flex-col items-center justify-center gap-2 sm:flex-row">
        <Button asChild className="group h-10 w-full gap-2 rounded-lg sm:w-auto">
          <Link to="/dashboard">
            Ir para o painel
            <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-0.5" />
          </Link>
        </Button>

        <Button
          variant="ghost"
          className="group h-10 w-full gap-2 rounded-lg text-muted-foreground hover:text-foreground sm:w-auto"
          onClick={() => window.history.back()}
        >
          <ArrowLeft className="h-4 w-4 transition-transform group-hover:-translate-x-0.5" />
          Voltar atrás
        </Button>
      </div>
    </div>
  </div>
);
